import React, { useState } from 'react';
import { Form, Button, Upload, Icon, Descriptions } from 'antd';
// import { SketchPicker } from 'react-color';
import { Text4 } from '../../styles';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../redux/actions';
import { handleApiExceptions, alertify, size_greater_than } from '../../app_methods';
import { MerchantService } from '../../services';
import './index.scss';
import { PermissionHoc } from '../HOC';

const PermissableButton = PermissionHoc(Button,"SETTINGS_WRITE_WHITE_LABEL",{ is_component: true, fallbackComponent: null })


let WhiteLabelSettings = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const file = props.form.getFieldValue('file') || null;
    const [isSaving, setIsSaving] = useState(false);

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (err) return;
            if (!values.file) return;
            if (values.file.file.type.indexOf("image") == -1) {
                handleApiExceptions("Only Image Extension files are allowed to upload.");
                return;
            }
            setIsSaving(true);
            const response = await MerchantService.save_settings({ ...values, key: props.current_user.key });
            if (!response.success) {
                setIsSaving(false);
                handleApiExceptions(response);
                return;
            }
            alertify("Success", "Settings saved successfully.", "success");
            setIsSaving(false);
            fetchMerchantInfo();
        });
    };

    return (
        <div className="w-50">
            <Descriptions column={1} bordered>
                <Descriptions.Item label="Merchant Login URL"><Text4 copyable>{props.current_user.white_label_setting && props.current_user.white_label_setting.login_url}</Text4></Descriptions.Item>
                <Descriptions.Item label="Logo">
                    <Form>
                        {/* <div className="mr-4">
                                <Form.Item label="Theme Color">
                                    {getFieldDecorator('theme', {
                                        valuePropName: 'color',
                                        initialValue: (props.current_user.white_label_setting && props.current_user.white_label_setting.theme) || "#001529"
                                    })(
                                        <SketchPicker
                                            width={200}
                                        />
                                    )}
                                </Form.Item>
                            </div> */}
                        <div className="white-label-logo-upload">
                            <Form.Item>
                                {getFieldDecorator('file', {
                                    valuePropName: 'file',
                                    rules: [{
                                        validator: (rule, value, callback) => {
                                            if (!value) {
                                                callback(true);
                                                return;
                                            }
                                            //const file = value.fileList[value.fileList.length-1];
                                            const file = value.file;
                                            size_greater_than(file, 1000000) ? callback(true) : callback();
                                        },
                                        message: "File size cannot exceed 1 MB"
                                    }]
                                })(
                                    <Upload.Dragger
                                        name='file'
                                        multiple={false}
                                        showUploadList={false}
                                        className="pl-0 d-block"
                                        beforeUpload={(file) => {
                                            return false;
                                        }}
                                        accept="image/*"
                                    >
                                        {
                                            props.current_user.white_label_setting && props.current_user.white_label_setting.logo_url ?
                                                <div style={{ margin: "auto", width: 160, height: "auto", overflow: "hidden", textAlign: "center", maxHeight: 65 }}>
                                                    <img style={{ margin: "auto", width: "auto", maxWidth: 150, maxHeight: 65 }} src={props.current_user.white_label_setting.logo_url} />
                                                </div>
                                                :
                                                <p className="ant-upload-drag-icon"><Icon type="inbox" /></p>
                                        }
                                        {
                                            file ? (
                                                <div className="mt-2 file-name-elipses">
                                                    <Text4 strong>Selected File:</Text4>
                                                    <Text4 className="ml-2">
                                                        {(file || {}).fileList[(file || {}).fileList.length - 1].name}
                                                    </Text4>
                                                </div>
                                            ) : <div className="mt-2">
                                                    <Text4 className="d-block">Click or drag file to this area to upload</Text4>
                                                </div>
                                        }
                                    </Upload.Dragger>
                                )}
                            </Form.Item>
                        </div>
                    </Form>
                </Descriptions.Item>
            </Descriptions>
            <div className="w-100 d-flex justify-content-end align-self-end mt-4">
                <PermissableButton type="primary" onClick={onSubmit} loading={isSaving}>Save</PermissableButton>
            </div>
        </div>
    )
};

WhiteLabelSettings = Form.create()(WhiteLabelSettings);

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(WhiteLabelSettings);